import Image from 'next/image'
import { styled, colors } from '../../styles/base/_allBase.styles'

export const GridContainer_Page_Layout = styled.div`
  min-height: 100dvh;
  display: grid;
  grid-template-rows: auto 1fr auto;
  background: ${colors.neutralPalette.white};
  color: ${colors.warmPalette.primaryDark};
`

export const MenuTopBar = styled.div`
  min-height: 7.2rem;
  padding: 0 4vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.neutralPalette.greyLight};
  background: rgba(244, 241, 233, 0.98);
  position: sticky;
  top: 0;
  z-index: 2;

  @media (max-width: 899px) {
    min-height: 6.4rem;
    padding: 0 2rem;
  }
`

export const MenuLogo = styled(Image)`
  display: block;
  width: clamp(18rem, 17vw, 23rem);
  max-width: 100%;
  height: auto;
`

export const CloseButton = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  color: inherit;
  min-height: 4.8rem;
  padding: 0.8rem 0 0.8rem 1.6rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  font-weight: 700;
  font-size: 1.4rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  svg { width: 3.2rem; height: 1.8rem; }
`

export const MenuContent = styled.div`
  width: min(118rem, 92vw);
  margin: 0 auto;
  padding: clamp(4rem, 8vh, 8rem) 0;
  display: grid;
  grid-template-columns: minmax(24rem, 0.75fr) minmax(0, 2fr);
  gap: clamp(4rem, 8vw, 10rem);

  @media (max-width: 767px) {
    width: min(100% - 4rem, 56rem);
    padding: 2rem 0 4rem;
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`

export const MenuIntro = styled.div`
  p {
    margin: 0 0 1rem;
    color: ${colors.warmPalette.textAccent};
    font-size: 1.3rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }

  h2 {
    margin: 0;
    max-width: 10ch;
    font-family: 'Whyte-Bold', 'AvenirNextLTPro-Regular', sans-serif;
    font-size: clamp(3.6rem, 5vw, 7rem);
    line-height: 0.98;
    letter-spacing: -0.035em;
    @media(max-width:767px) { font-size:2.6rem; max-width:none; line-height:1.2; }
  }
`

export const MenuGrid = styled.nav`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: clamp(3rem, 5vw, 7rem);

  @media (max-width: 599px) {
    grid-template-columns: 1fr;
  }
`

export const MenuGroup = styled.section`
  padding: 1.7rem 0 1.8rem;
  border-top: 1px solid ${colors.neutralPalette.greyLight};
`

export const GroupHeading = styled.h3`
  margin: 0;
  font-family: 'Whyte-Bold', 'AvenirNextLTPro-Regular', sans-serif;
  font-size: clamp(2rem, 2vw, 2.6rem);
  line-height: 1.2;

  a {
    display: inline-block;
    padding: 0.4rem 0;
    min-height:4.4rem;
  }
  a[aria-current] { text-decoration:underline; text-underline-offset:.35em; }
`

export const MotionUl = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0.7rem 0 0;
`

export const MotionLi = styled.li`
  a {
    display: inline-flex;
    align-items: center;
    min-height: 4.4rem;
    color: ${colors.neutralPalette.greyDark};
    font-size: 1.6rem;
    text-decoration: underline;
    text-decoration-color: transparent;
    text-underline-offset: 0.35em;
    transition: color 160ms ease, text-decoration-color 160ms ease;
  }

  a:hover, a:focus-visible {
    color: ${colors.warmPalette.primary};
    text-decoration-color: currentColor;
  }
`

export const FooterContainer = styled.div`
  width: min(118rem, 92vw);
  margin: 0 auto;
  padding: 2.4rem 0 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  border-top: 1px solid ${colors.neutralPalette.greyLight};

  @media (max-width: 599px) {
    width: min(100% - 4rem, 56rem);
    align-items: flex-start;
    flex-direction: column;
  }
`

export const SocialContainer = styled.div`
  display: flex;
  gap: 1rem;
`

export const PrivacyContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 2.4rem;

  a {
    min-height: 4.4rem;
    display: inline-flex;
    align-items: center;
    font-size: 1.4rem;
    font-weight: 600;
  }
`

export const NavImage = styled.span`
  width: 4.4rem;
  height: 4.4rem;
  display: grid;
  place-items: center;
  border: 1px solid ${colors.neutralPalette.greyLight};
  border-radius: 50%;

  svg { width: 1.8rem; height: 1.8rem; }
`

export const GridItem1 = styled.div``
export const GridItem2 = styled.div``
export const MotionP = styled.p``
export const BookNowContainer = styled.div``
